import { useContext } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  ModalContext,
  ComponentLoader,
  AlloyButton
} from 'cat-ecommerce-alloy';
import { replaceTokensInString } from '../../../../utils';
import SaveEquipment from '../../../pages/my-equipment/AddEquipmentModal/SearchSuggestions/EquipmentSuggestions/SaveEquipment';
import styles from '../myEquipmentHeader.scss';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer/useEquipmentDrawer';

const DisplayEquipment = props => {
  const { mccRedirect } = queryString.parse(window.location.href);
  const {
    selectedEquipment,
    isFilteredByEquipment,
    loading,
    myEquipmentList,
    hideCheckbox,
    displaySSROCTA,
    widgetIdentifier,
    openEditDrawer
  } = props;
  const { openSelectDrawer, getDrawerComponent } = useEquipmentDrawer();
  const modalCtx = useContext(ModalContext);
  const { t } = useTranslation();
  const str = !!isFilteredByEquipment
    ? 'MEQ2_SHOWINGPARTS4'
    : 'MEQ2_SHOWPARTS4';
  const label = replaceTokensInString(t(str), selectedEquipment.model);
  const { isQRCodeTempEquipment } = selectedEquipment;
  const modalTitle = t('SAVE_MY_EQUIPMENT');
  const defaultProps = {
    modalTitle,
    currentEquipment: selectedEquipment,
    widgetIdentifier
  };

  const filterResultsForEquipment = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('filterByEquipment', !isFilteredByEquipment);
    window.location.href = `${url.pathname}${url.search}`;
  };
  return (
    <>
      <div
        id="mySelectedEquipment"
        className={`${styles['equipment-fitment__selected-equipment']}`}
      >
        {loading ? (
          <ComponentLoader />
        ) : (
          <>
            <div className={`${styles['equipment-fitment__img']}`}>
              <img
                data-testid="equipmentImg"
                loading="lazy"
                alt={`${selectedEquipment.model} ${selectedEquipment.equipmentFamily}`}
                src={`${selectedEquipment.imageURL}?hei=120&wid=120&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0`}
              />
            </div>
            <div className={`${styles['equipment-fitment__details']}`}>
              <h2>
                {selectedEquipment.model} {selectedEquipment.equipmentFamily}
              </h2>
              {selectedEquipment.serialNumber && (
                <p className={`${styles['equipment-fitment__serial']}`}>
                  {t('MEQ_SERIAL')} {selectedEquipment.serialNumber}
                </p>
              )}
              {!selectedEquipment.serialNumber && (
                <p className={`${styles['equipment-fitment__add-serial']}`}>
                  <button
                    type="button"
                    data-testid="enterSerialBtn"
                    onClick={() => {
                      isQRCodeTempEquipment
                        ? modalCtx.addModalWithOptions(
                            <SaveEquipment
                              {...defaultProps}
                              isTempEquipmentMessage
                            />,
                            modalTitle
                          )
                        : openEditDrawer();
                    }}
                  >
                    {t('MEQ_ENTER_SERIAL_CAT1')}
                  </button>{' '}
                  {t('MEQ_ENTER_SERIAL_CAT2')}
                </p>
              )}
              {!hideCheckbox && !mccRedirect ? (
                <Checkbox
                  id="filterByEquipmentCheckBox"
                  data-testid="filterCheckbox"
                  label={label}
                  name="filterForEquipment"
                  onChange={filterResultsForEquipment}
                  checked={!!isFilteredByEquipment}
                />
              ) : (
                !hideCheckbox && <p>{label}</p>
              )}
              {/** This condition is for ssro campaign page */}
              {displaySSROCTA && (
                <div>
                  <a
                    className={`btn btn-ghost btn-sm ps-0`}
                    href={selectedEquipment.seoUrl}
                  >
                    {t('PARTS_RESOURCES_SSRO')}
                  </a>
                  <AlloyButton
                    className="ps-0"
                    buttonType="ghost"
                    onClick={openSelectDrawer}
                  >
                    {t('CHANGE_EQUIPMENT')}
                  </AlloyButton>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {getDrawerComponent({
        currentEquipment: selectedEquipment,
        myEquipmentList: myEquipmentList
      })}
    </>
  );
};

DisplayEquipment.propTypes = {
  selectedEquipment: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  ),
  isFilteredByEquipment: PropTypes.bool,
  myEquipmentList: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string]))
  ),
  loading: PropTypes.bool,
  hideCheckbox: PropTypes.bool,
  displaySSROCTA: PropTypes.bool,
  widgetIdentifier: PropTypes.string,
  openEditDrawer: PropTypes.func
};

export default DisplayEquipment;
